import { HandleDownIcon, HandleDragIcon, HandleUpIcon } from "./icons";
import css from "./index.module.scss";
import classNames from "classnames";

export type HandleDndProps = {
  sortableProps?: AISaasOutput.RenderSortableProps;
  onClickSortable?: AISaasOutput.OnClickSortableHandler;
};

export default function HandleDnd({ sortableProps, onClickSortable }: HandleDndProps) {
  const { id, setNodeRef, attributes, listeners } = sortableProps || {};

  return (
    <div className={classNames(css["toolbar-dnd"], css["vertical-icons"])} data-testid="Toolbar-Handle">
      <div
        className={css["handle-prev"]}
        data-testid="Toolbar-Handle-Prev"
        onClick={e => {
          id && onClickSortable?.({ id, type: "up" });
        }}
      >
        {HandleUpIcon}
      </div>
      <div
        className={css["handle-drag"]}
        data-testid="Toolbar-Handle-Drag"
        ref={setNodeRef}
        {...attributes}
        {...listeners}
      >
        {HandleDragIcon}
      </div>
      <div
        className={css["handle-next"]}
        data-testid="Toolbar-Handle-Down"
        onClick={e => {
          id && onClickSortable?.({ id, type: "down" });
        }}
      >
        {HandleDownIcon}
      </div>
    </div>
  );
}
